import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { OrderApprovalAuthorityColumns, OrderApprovalAuthorityColumnsWithoutStockholder } from "../../tableColumns/table-columns";
import { OrderApprovalAuthorityJson } from "../../DynamicFormsJson/MastersJSON/orderApprovalAuthority";
import { getOrderApprovalAuthority } from "../../Slice/orderApprovalAuthority.slice";
import { apiPost } from "../../utils/api_service";
import endpoint from "../../config/endpoints";
import { noInternetMsg, statusFailedMsg, statusmsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";
class OrderApprovalAuthorityTable extends React.Component {
    constructor(props) {
        super(props);
    }

    onChangeStatus = (rowData) => {
        const { showLoador, showNotification, getOrderApprovalAuthority } = this.props;
        if (navigator.onLine) {
            let status = "";
            if (rowData.isActive == 0) {
                status = 1;
            } else {
                status = 0;
            }
            showLoador({ loador: true });
            apiPost({
                url:
                    endpoint.orderApprovalAuthority +
                    "/update-is-active?id=" +
                    rowData.id +
                    "&status=" +
                    status,
            }).then(({ data, success }) => {
                if (success) {
                    showNotification({ msg: statusmsg });
                    getOrderApprovalAuthority();
                } else {
                    showNotification({ msg: statusFailedMsg, severity: "error" });
                }
            });
            showLoador({ loador: false });

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    render() {
        const { orderApprovalAuthority, getOrderApprovalAuthority } = this.props;
        const hideStockHolderOnOrderApproval = localStorage.getItem("hideStockHolderOnOrderApproval") !== null ? localStorage.getItem("hideStockHolderOnOrderApproval") : 1;
        return (
            <>
                <DynamicMainScreen
                    formPath={OrderApprovalAuthorityJson.formPath}
                    screenTitle={OrderApprovalAuthorityJson.screenTitle}
                    fieldMeta={OrderApprovalAuthorityJson.fieldMeta}
                    showPdfDownload={OrderApprovalAuthorityJson.showPdfDownload}
                    showExcelDownload={true}
                    filterDataExcel={true}
                    showExtension={false}
                    pdfFileName={OrderApprovalAuthorityJson.pdfFileName}
                    excelFileName={OrderApprovalAuthorityJson.excelFileName}
                    showAddButton={OrderApprovalAuthorityJson.showAddButton}
                    tableColumnsToFilter={OrderApprovalAuthorityJson.tableColumnsToFilter}
                    tableColumns={hideStockHolderOnOrderApproval == 1 ?
                        OrderApprovalAuthorityColumnsWithoutStockholder : OrderApprovalAuthorityColumns}
                    tableData={orderApprovalAuthority?.orderApprovalAuthority}
                    getTableData={getOrderApprovalAuthority}
                    apiBaseURL={OrderApprovalAuthorityJson.apiBaseURL}
                    baseIdColumn={OrderApprovalAuthorityJson.baseIdColumn}
                    showDeleteIcon={true}
                    showViewButtonInTable={false}
                    isActiveURLFalse={true}
                    isActiveURLFalseMethod={this.onChangeStatus}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    orderApprovalAuthority: state.orderApprovalAuthority,
});
const mapDispatchToProps = {
    getOrderApprovalAuthority,
    showLoador,
    showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderApprovalAuthorityTable);
